import {FEATURED_RACE} from "../../config";
import {ClubEvent, parseDate, today, useEvents} from "../../data/sheet";

export interface FeaturedRace {
    title: string; subtitle: string; start: Date; end: Date; place: string; image: string; link: string;
}

/* Course mise en avant : 1re course à venir marquée "Mise en avant = oui" dans le Sheet,
   sinon la course définie dans src/config.ts. */
export default function useFeaturedRace(): FeaturedRace {
    const {data} = useEvents();
    const f: ClubEvent | undefined = data.find(e => e.featured && e.end >= today());
    if (f) return {
        title: f.title, subtitle: f.description || f.type || FEATURED_RACE.subtitle, start: f.start, end: f.end,
        place: f.place, image: f.image || FEATURED_RACE.image, link: f.link || FEATURED_RACE.link,
    };
    return {
        ...FEATURED_RACE,
        start: parseDate(FEATURED_RACE.dateStart)!, end: parseDate(FEATURED_RACE.dateEnd)!,
    };
}
